import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { CmsFormPanel, PanelContent, PanelHeader, PanelTitle, PanelTrigger } from '@/components/shared/CmsFormPanel';
import { Plus } from 'lucide-react';
import { ConfirmDialog } from '@/components/shared';

interface TshirtSizesFormDialogProps {
  isDialogOpen: boolean;
  setIsDialogOpen: (open: boolean) => void;
  editingSize: any;
  setEditingSize: (size: any) => void;
  formData: { size: string; sortOrder: number; raceTypeId: string };
  setFormData: React.Dispatch<React.SetStateAction<{ size: string; sortOrder: number; raceTypeId: string }>>;
  handleSubmit: (e: React.FormEvent) => void;
  raceTypes: any[];
  selectedRaceId: string;
  selectedRaceTypeId: string;
  sizes: any[];
  addDefaultSizes: () => void;
  deleteTarget: any;
  setDeleteTarget: (val: any) => void;
  confirmDelete: () => void;
}

const TshirtSizesFormDialog: React.FC<TshirtSizesFormDialogProps> = ({
  isDialogOpen, setIsDialogOpen, editingSize, setEditingSize,
  formData, setFormData, handleSubmit, raceTypes,
  selectedRaceId, selectedRaceTypeId, sizes, addDefaultSizes,
  deleteTarget, setDeleteTarget, confirmDelete,
}) => (
  <>
    <div className="flex gap-2">
      {selectedRaceId && sizes.length === 0 && (
        <Button variant="outline" onClick={addDefaultSizes}>
          Додади стандардни
        </Button>
      )}
      <CmsFormPanel open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <PanelTrigger asChild>
          <Button
            disabled={!selectedRaceId}
            onClick={() => {
              setEditingSize(null);
              setFormData({ size: '', sortOrder: sizes.length, raceTypeId: selectedRaceTypeId || '' });
            }}
          >
            <Plus className="w-4 h-4 mr-2" />
            Додај големина
          </Button>
        </PanelTrigger>
        <PanelContent>
          <PanelHeader>
            <PanelTitle>
              {editingSize ? 'Измени големина' : 'Додај нова големина'}
            </PanelTitle>
          </PanelHeader>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="size">Големина *</Label>
              <Input
                id="size"
                value={formData.size}
                onChange={(e) => setFormData({ ...formData, size: e.target.value })}
                placeholder="нпр. S, M, L, XL, XXL"
                required
              />
            </div>
            <div>
              <Label htmlFor="sortOrder">Редослед на прикажување</Label>
              <Input
                id="sortOrder"
                type="number"
                min="0"
                value={formData.sortOrder}
                onChange={(e) => setFormData({ ...formData, sortOrder: Number(e.target.value) })}
              />
              <p className="text-xs text-muted-foreground mt-1">
                Помал број = прва позиција
              </p>
            </div>
            <div>
              <Label htmlFor="raceTypeId">Тип на трка</Label>
              <select
                id="raceTypeId"
                value={formData.raceTypeId}
                onChange={(e) => setFormData({ ...formData, raceTypeId: e.target.value })}
                className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              >
                <option value="">-- Сите типови (општо) --</option>
                {raceTypes.map((rt: any) => (
                  <option key={rt.id} value={rt.id}>{rt.name}</option>
                ))}
              </select>
              <p className="text-xs text-muted-foreground mt-1">
                Оставете празно за големина достапна за сите типови на трка
              </p>
            </div>
            <div className="flex justify-end space-x-2 pt-4">
              <Button type="button" variant="outline" onClick={() => setIsDialogOpen(false)}>
                Откажи
              </Button>
              <Button type="submit">
                {editingSize ? 'Зачувај промени' : 'Додај'}
              </Button>
            </div>
          </form>
        </PanelContent>
      </CmsFormPanel>
    </div>
    <ConfirmDialog
      open={deleteTarget !== null}
      onOpenChange={(open) => !open && setDeleteTarget(null)}
      title="Избриши големина"
      description="Дали сте сигурни дека сакате да ја избришете оваа големина?"
      onConfirm={confirmDelete}
    />
  </>
);

export default TshirtSizesFormDialog;
